class SparkleAnimation extends HTMLElement {
  constructor() {
    super();
    this.lottiePlayer = null;
    this.resizeObserver = null;
    this.baseAnimationData = null;

    // Embed new animation data from stars-left.json
    this.animationData = {
      v: "5.9.0",
      fr: 24,
      ip: 0,
      op: 96,
      w: 90,
      h: 70,
      nm: "Stars-Left-R2",
      ddd: 0,
      assets: [
        {
          id: "comp_0",
          nm: "Star 1",
          fr: 24,
          layers: [
            {
              ddd: 0,
              ind: 1,
              ty: 1,
              nm: "Dark Magenta-Red Solid 1",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [1500, 1500, 0], ix: 2, l: 2 },
                a: { a: 0, k: [60, 35, 0], ix: 1, l: 2 },
                s: { a: 0, k: [4756.31, 4756.31, 100], ix: 6, l: 2 },
              },
              ao: 0,
              hasMask: true,
              masksProperties: [
                {
                  inv: false,
                  mode: "a",
                  pt: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0.566, -0.142],
                        [0, 0],
                        [0.086, 0.301],
                        [0, 0],
                        [0.16, -0.561],
                        [0, 0],
                        [0.304, 0.076],
                        [0, 0],
                        [-0.406, -0.419],
                        [0, 0],
                        [0.218, -0.225],
                        [0, 0],
                        [-0.566, 0.142],
                        [0, 0],
                        [-0.086, -0.301],
                        [0, 0],
                        [-0.16, 0.561],
                        [0, 0],
                        [-0.304, -0.076],
                        [0, 0],
                        [0.406, 0.419],
                        [0, 0],
                        [-0.218, 0.225],
                      ],
                      o: [
                        [0.406, -0.419],
                        [0, 0],
                        [-0.304, 0.076],
                        [0, 0],
                        [-0.16, -0.561],
                        [0, 0],
                        [-0.086, 0.301],
                        [0, 0],
                        [-0.566, -0.142],
                        [0, 0],
                        [0.218, 0.225],
                        [0, 0],
                        [-0.406, 0.419],
                        [0, 0],
                        [0.304, -0.076],
                        [0, 0],
                        [0.16, 0.561],
                        [0, 0],
                        [0.086, -0.301],
                        [0, 0],
                        [0.566, 0.142],
                        [0, 0],
                        [-0.218, -0.225],
                        [0, 0],
                      ],
                      v: [
                        [83.14, 22.284],
                        [82.582, 21.318],
                        [65.96, 25.485],
                        [65.261, 25.081],
                        [60.558, 8.602],
                        [59.442, 8.602],
                        [54.739, 25.081],
                        [54.041, 25.485],
                        [37.418, 21.318],
                        [36.86, 22.284],
                        [48.78, 34.596],
                        [48.78, 35.404],
                        [36.86, 47.716],
                        [37.418, 48.682],
                        [54.041, 44.515],
                        [54.739, 44.919],
                        [59.442, 61.398],
                        [60.558, 61.398],
                        [65.261, 44.919],
                        [65.96, 44.515],
                        [82.582, 48.682],
                        [83.14, 47.716],
                        [71.22, 35.404],
                        [71.22, 34.596],
                      ],
                      c: true,
                    },
                    ix: 1,
                  },
                  o: { a: 0, k: 100, ix: 3 },
                  x: { a: 0, k: 0, ix: 4 },
                  nm: "Mask 1",
                },
              ],
              sw: 120,
              sh: 70,
              sc: "#C7893A",
              ip: 0,
              op: 288,
              st: 0,
              bm: 0,
            },
            {
              ddd: 0,
              ind: 2,
              ty: 1,
              nm: "White Solid 1",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [1500, 1500, 0], ix: 2, l: 2 },
                a: { a: 0, k: [60, 35, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
              },
              ao: 0,
              sw: 120,
              sh: 70,
              sc: "#ffffff",
              ip: 0,
              op: 288,
              st: 0,
              bm: 0,
            },
          ],
        },
        {
          id: "comp_1",
          nm: "Star 2",
          fr: 24,
          layers: [
            {
              ddd: 0,
              ind: 1,
              ty: 1,
              nm: "Dark Magenta-Red Solid 1",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [1500, 1500, 0], ix: 2, l: 2 },
                a: { a: 0, k: [60, 35, 0], ix: 1, l: 2 },
                s: { a: 0, k: [4756.31, 4756.31, 100], ix: 6, l: 2 },
              },
              ao: 0,
              hasMask: true,
              masksProperties: [
                {
                  inv: false,
                  mode: "a",
                  pt: {
                    a: 0,
                    k: {
                      i: [
                        [1.017, 0.253],
                        [0, 0],
                        [0.09, 0.361],
                        [0, 0],
                        [0.253, -1.017],
                        [0, 0],
                        [0.361, -0.09],
                        [0, 0],
                        [-1.017, -0.253],
                        [0, 0],
                        [-0.09, -0.361],
                        [0, 0],
                        [-0.253, 1.017],
                        [0, 0],
                        [-0.361, 0.09],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-0.361, -0.09],
                        [0, 0],
                        [-0.253, -1.017],
                        [0, 0],
                        [-0.09, 0.361],
                        [0, 0],
                        [-1.017, 0.253],
                        [0, 0],
                        [0.361, 0.09],
                        [0, 0],
                        [0.253, 1.017],
                        [0, 0],
                        [0.09, -0.361],
                        [0, 0],
                        [1.017, -0.253],
                      ],
                      v: [
                        [83.463, 34.024],
                        [66.045, 29.688],
                        [65.312, 28.955],
                        [60.976, 11.537],
                        [59.024, 11.537],
                        [54.688, 28.955],
                        [53.955, 29.688],
                        [36.537, 34.024],
                        [36.537, 35.976],
                        [53.955, 40.312],
                        [54.688, 41.045],
                        [59.024, 58.463],
                        [60.976, 58.463],
                        [65.312, 41.045],
                        [66.045, 40.312],
                        [83.463, 35.976],
                      ],
                      c: true,
                    },
                    ix: 1,
                  },
                  o: { a: 0, k: 100, ix: 3 },
                  x: { a: 0, k: 0, ix: 4 },
                  nm: "Mask 1",
                },
              ],
              sw: 120,
              sh: 70,
              sc: "#C7893A",
              ip: 0,
              op: 288,
              st: 0,
              bm: 0,
            },
            {
              ddd: 0,
              ind: 2,
              ty: 1,
              nm: "White Solid 1",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [1500, 1500, 0], ix: 2, l: 2 },
                a: { a: 0, k: [60, 35, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
              },
              ao: 0,
              sw: 120,
              sh: 70,
              sc: "#ffffff",
              ip: 0,
              op: 288,
              st: 0,
              bm: 0,
            },
          ],
        },
      ],
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 0,
          nm: "Star 1",
          refId: "comp_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 18,
                  s: [0],
                },
                { t: 51, s: [180] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 18,
                  s: [80.25, 27.25, 0],
                  to: [0, 0, 0],
                  ti: [24.1, -2.141, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 41,
                  s: [38.6, 10.609, 0],
                  to: [-24.1, 2.141, 0],
                  ti: [0, 0, 0],
                },
                { t: 51, s: [5.75, 25.25, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [1500, 1500, 0], ix: 1, l: 2 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 18,
                  s: [0, 0, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 41,
                  s: [-0.714, -0.714, 100],
                },
                { t: 51, s: [0, 0, 100] },
              ],
              ix: 6,
              l: 2,
            },
          },
          ao: 0,
          w: 3000,
          h: 3000,
          ip: 14,
          op: 302,
          st: 14,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 0,
          nm: "Star 1",
          refId: "comp_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 31,
                  s: [0],
                },
                { t: 64, s: [180] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 31,
                  s: [84.25, 42.25, 0],
                  to: [0, 0, 0],
                  ti: [21.376, 1.17, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 48,
                  s: [46.876, 30.67, 0],
                  to: [-21.376, -1.17, 0],
                  ti: [0, 0, 0],
                },
                { t: 64, s: [9, 36.25, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [1500, 1500, 0], ix: 1, l: 2 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 31,
                  s: [0, 0, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 48,
                  s: [-0.789, -0.789, 100],
                },
                { t: 64, s: [0, 0, 100] },
              ],
              ix: 6,
              l: 2,
            },
          },
          ao: 0,
          w: 3000,
          h: 3000,
          ip: 18,
          op: 306,
          st: 18,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 0,
          nm: "Star 2",
          refId: "comp_1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 43,
                  s: [0],
                },
                { t: 76, s: [180] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 43,
                  s: [83, 40.75, 0],
                  to: [0, 0, 0],
                  ti: [25.75, 1.5, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 62,
                  s: [41.25, 57.25, 0],
                  to: [-25.75, -1.5, 0],
                  ti: [0, 0, 0],
                },
                { t: 76, s: [5.75, 42.25, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [1500, 1500, 0], ix: 1, l: 2 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 43,
                  s: [0, 0, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 62,
                  s: [0.9, 0.9, 100],
                },
                { t: 76, s: [0, 0, 100] },
              ],
              ix: 6,
              l: 2,
            },
          },
          ao: 0,
          w: 3000,
          h: 3000,
          ip: -3,
          op: 285,
          st: -3,
          bm: 0,
        },
      ],
      markers: [],
    };
  }
  connectedCallback() {
    // Apply custom color if provided
    const customColor = this.getAttribute("color");
    if (customColor) {
      this.applyCustomColor(customColor);
    }

    // Create a simple test element to ensure the component is working
    this.createTestElement();

    // Wait a bit for Lottie library to load, then initialize
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      // Small delay to ensure Lottie library is loaded
      setTimeout(() => this.init(), 100);
    }
  }

  applyCustomColor(hexColor) {
    // Ensure hex color starts with #
    if (!hexColor.startsWith("#")) {
      hexColor = "#" + hexColor;
    }

    // Only clone if color is different from default
    if (hexColor === "#34141d") return;

    // Use structured cloning for better performance
    const clonedData = structuredClone(this.animationData);

    // Update colors in the cloned data
    clonedData.assets.forEach((asset) => {
      if (asset.layers) {
        asset.layers.forEach((layer) => {
          if (layer.sc === "#34141d") {
            layer.sc = hexColor;
          }
        });
      }
    });

    this.animationData = clonedData;
  }

  createTestElement() {
    // Get position attribute (default to 'left')
    const position = this.getAttribute("position") || "left";

    // Base styles
    this.style.position = "absolute";
    this.style.top = "50%";
    this.style.width = "28px";
    this.style.height = "22px";
    this.style.pointerEvents = "none";
    this.style.overflow = "visible";
    this.style.zIndex = "10";

    // Position-specific styles
    if (position === "right") {
      this.style.right = "-16px";
      this.style.transform = "translateY(-50%) scaleX(-1)"; // Mirror the animation
    } else {
      this.style.left = "-16px";
      this.style.transform = "translateY(-50%)";
    }

    // Try to create Lottie player immediately
    setTimeout(() => {
      this.createLottiePlayer();
    }, 100);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    try {
      // Set a timeout to check if Lottie loaded within 3 seconds
      this.fallbackTimeout = setTimeout(() => {
        if (!this.animationStarted) {
          // Animation failed to start - fail silently
        }
      }, 3000);

      // Try Lottie first
      this.createLottiePlayer();

      // Set up responsive sizing
      this.setupResponsiveSizing();
    } catch (error) {
      // Fail silently in production
    }
  }

  createLottiePlayer() {
    // Check if lottie-player is available
    const lottiePlayerAvailable =
      customElements.get("lottie-player") || window.LottiePlayer;

    if (!lottiePlayerAvailable) {
      // Lazy-load Lottie player library on demand
      if (!window._lottiePlayerLoading) {
        window._lottiePlayerLoading = true;
        window._lottiePlayerCallbacks = window._lottiePlayerCallbacks || [];
        
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
        script.onload = () => {
          window._lottiePlayerLoading = false;
          // Notify all waiting components
          const callbacks = window._lottiePlayerCallbacks || [];
          callbacks.forEach(cb => cb());
          window._lottiePlayerCallbacks = [];
        };
        document.head.appendChild(script);
      }
      
      // Register this component's callback
      window._lottiePlayerCallbacks = window._lottiePlayerCallbacks || [];
      if (!window._lottiePlayerCallbacks.includes(this.createLottiePlayer.bind(this))) {
        window._lottiePlayerCallbacks.push(this.createLottiePlayer.bind(this));
      }
      return;
    }

    try {
      this.lottiePlayer = document.createElement("lottie-player");

      // Set attributes
      this.lottiePlayer.setAttribute("autoplay", "");
      this.lottiePlayer.setAttribute("loop", "");
      this.lottiePlayer.setAttribute("mode", "normal");
      this.lottiePlayer.setAttribute("background", "transparent");

      // Set styles to fill container (90x70)
      this.lottiePlayer.style.position = "absolute";
      this.lottiePlayer.style.top = "0";
      this.lottiePlayer.style.left = "0";
      this.lottiePlayer.style.width = "100%";
      this.lottiePlayer.style.height = "100%";
      this.lottiePlayer.style.pointerEvents = "none";
      this.lottiePlayer.style.zIndex = "10";
      this.lottiePlayer.style.transformOrigin = "center center";

      // Add to DOM first
      this.appendChild(this.lottiePlayer);

      // Set up event listeners
      this.lottiePlayer.addEventListener("ready", () => {
        this.animationStarted = true;
        if (this.fallbackTimeout) {
          clearTimeout(this.fallbackTimeout);
        }
        this.ensureLooping();
        this.startAnimation();
      });

      this.lottiePlayer.addEventListener("complete", () => {
        this.startAnimation();
      });

      this.lottiePlayer.addEventListener("error", () => {
        this.lottiePlayer.remove();
      });

      // Load animation data after a short delay to ensure element is ready
      setTimeout(() => {
        try {
          // Try different methods to load the animation
          if (this.lottiePlayer.load) {
            this.lottiePlayer.load(this.animationData);
          } else if (this.lottiePlayer.loadAnimation) {
            this.lottiePlayer.loadAnimation(this.animationData);
          } else {
            // Try setting the src attribute with a data URL
            const dataUrl =
              "data:application/json;base64," +
              btoa(JSON.stringify(this.animationData));
            this.lottiePlayer.setAttribute("src", dataUrl);
          }

          // Fallback timeout - if animation doesn't start in 2 seconds, remove player
          setTimeout(() => {
            if (
              !this.lottiePlayer.getLottie ||
              !this.lottiePlayer.getLottie()
            ) {
              this.lottiePlayer.remove();
            }
          }, 2000);
        } catch (error) {
          this.lottiePlayer.remove();
        }
      }, 200);
    } catch (error) {
      // Fail silently
    }
  }

  setupResponsiveSizing() {
    const parentElement = this.parentElement;
    if (!parentElement) return;

    // Ensure parent containers allow overflow for the animation
    this.ensureOverflowVisible(parentElement);

    // Set initial size
    this.updateSize();

    // Watch for size changes
    this.resizeObserver = new ResizeObserver(() => {
      this.updateSize();
    });

    this.resizeObserver.observe(parentElement);
  }

  ensureOverflowVisible(element) {
    // Walk up the DOM tree to ensure containers don't clip the animation
    let current = element;
    let depth = 0;

    while (current && depth < 5) {
      // Limit depth to avoid going too far up
      const computedStyle = window.getComputedStyle(current);

      // If overflow is hidden, set it to visible for navigation areas
      if (
        computedStyle.overflow === "hidden" ||
        computedStyle.overflowX === "hidden" ||
        computedStyle.overflowY === "hidden"
      ) {
        // Only modify if it looks like a navigation container
        if (
          current.classList.contains("header__link-list") ||
          current.tagName === "NAV" ||
          current.classList.contains("navigation") ||
          current.tagName === "SUMMARY" ||
          current.tagName === "DETAILS"
        ) {
          current.style.overflow = "visible";
        }
      }

      current = current.parentElement;
      depth++;
    }
  }

  updateSize() {
    // Animation uses container size (90x70) - no need to update
    if (!this.lottiePlayer) return;
  }

  ensureLooping() {
    if (!this.lottiePlayer) return;

    try {
      // Method 1: Set loop attribute
      this.lottiePlayer.setAttribute("loop", "");

      // Method 2: Set loop property
      if (this.lottiePlayer.loop !== undefined) {
        this.lottiePlayer.loop = true;
      }

      // Method 3: Access the underlying Lottie instance
      const lottieInstance =
        this.lottiePlayer.getLottie && this.lottiePlayer.getLottie();
      if (lottieInstance) {
        lottieInstance.loop = true;
        lottieInstance.setLoop(true);
      }
    } catch (error) {
      // Fail silently
    }
  }

  startAnimation() {
    if (this.lottiePlayer) {
      try {
        // Ensure looping before playing
        this.ensureLooping();

        // Method 1: Use play method
        if (this.lottiePlayer.play) {
          this.lottiePlayer.play();
        }

        // Method 2: Set autoplay attribute
        this.lottiePlayer.setAttribute("autoplay", "");

        // Method 3: Access underlying Lottie instance
        const lottieInstance =
          this.lottiePlayer.getLottie && this.lottiePlayer.getLottie();
        if (lottieInstance) {
          lottieInstance.play();
          lottieInstance.loop = true;
        }
      } catch (error) {
        // Fail silently
      }
    }
  }

  stopAnimation() {
    if (this.lottiePlayer) {
      try {
        if (this.lottiePlayer.pause) {
          this.lottiePlayer.pause();
        }

        const lottieInstance =
          this.lottiePlayer.getLottie && this.lottiePlayer.getLottie();
        if (lottieInstance) {
          lottieInstance.pause();
        }
      } catch (error) {
        // Fail silently
      }
    }
  }
}

// Register the custom element
customElements.define("sparkle-animation", SparkleAnimation);
